module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-a57ba5806529a8e1d29753152b9391c0.png";